import { Box, Container, createStyles, Flex, Input, Text } from "@mantine/core";

import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CustomPagination from "../../components/Pagination/CustomPagination";
import PlanTable from "../../components/PlanTable";
import { getPlans, getSinglePlan } from "../../services/supportplan";
import AddButton from "../AddButton";
import SelectCarePlanTypeModal from "../SelectCarePlanTypeModal";
import { FaPlus } from "react-icons/fa6";
import CarePlanDetailsDrawer from "./CarePlanDetailsDrawer";
import { IconSearch } from "@tabler/icons-react";
import { NoDiscontinuedPlansSvg } from "../Svgs/NoDiscontinuedPlansSvg";
import { NoCarePlanDataSvg } from "../Svgs/NoCarePlanDataSvg";
import { useLocation } from "react-router-dom";
import { decrypt } from "../../utils";
import { isStaff } from "../../http";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflowX: "auto",
    // ".mantine-rhlimb":{
    //   padding: "unset !important",
    // },
    // "& .mantine-p2ocmu": {
    //   borderRadius: "1rem 0 0 1rem !important",
    // },
  },
  btn: {
    // marginLeft: "auto",
    // marginTop: 5,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: 10,
    backgroundColor: "#FFF",
    borderRadius: "8px",
    marginInline: "3px",
    padding: "12px 16px",
  },
  mymodal: {
    width: 818,
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
  },
  mwd: {
    width: "100%",
  },
  firsttext: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    gap: 10,
    marginTop: 50,
    cursor: "pointer",
  },
  pagination: {
    margin: "1rem 0",
    display: "flex",
    alignItems: "end",
    justifyContent: "end",
  },
  segmentBTN: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "12px",
  },
  tabContainer: {
    display: "flex",
    minWidth: "260px",
    padding: "6px 8px",
    borderRadius: "6px",
    border: "1px solid #E5E5E5",
    background: "#F5F5F5",
  },
  activeTab: {
    background: "#FFF",
    border: "1px solid #E5E5E5",
  },
  tab: {
    display: "flex",
    alignItems: "center",
    borderRadius: "4px",
    padding: "8px 16px",
    background: "transparent",
    cursor: "pointer",
    "& p": {
      margin: "0",
      color: "#262626",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
    "& img": {
      width: "24px",
      marginRight: "5px",
    },
  },
  disableTab: {
    cursor: "not-allowed",
  },

  searchInput: {
    width: "55%",
    height: "auto",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    "& .mantine-Input-input": {
      fontFamily: "Inter",
      border: "none",
      backgroundColor: "transparent",
      height: "44px",
      fontFamily: "Inter",
    },
  },
  noDataContainer: {
    padding: "41px",
    backgroundColor: "#FFF",
    border: "1px solid #E5E5E5",
    borderRadius: "20px",
    flex: "0 1 50rem",
    "& .iconParent": {
      width: "158px",
      height: "158px",
      borderRadius: "79px",
      borderTop: "1px solid #D4D4D4",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background:
        "linear-gradient(180deg, #F1F1F1 0%, rgba(255, 255, 255, 0.00) 81.19%)",
    },
  },
}));
export const planTypeLabels = {
  1: {
    typeTitle: "Support",
    outcomeNumberLabel: "Outcome Number",
    outcomeTitleLabel: "Outcome Title",
    outcomeCategoryLabel: "Outcome Category",
    supportActivityLabel: "Support Activity",
    supportInstructionsLabel: "Support Instructions",
    howOftenLabel: "Outcome Frequency",
    noLongerNeedLabel: "No longer need this outcome when ..",
    additionalNoteLabel: "Additional Note",
    addNewDetailsLabel: "Add More Activity Details",
    addNewButtonLabel: "Outcome",
    categoryData: [
      "Community Living",
      "Safety and Security",
      "Healthy living",
      "Citizenship & Advocacy",
      "Daily Life & Employment",
      "Social & Spirituality",
      "Integrated Community Involvement",
      "Community Engagement",
      "Other",
    ],
  },
  // Treatment and Intervention labels
  2: {
    typeTitle: "Intervention",
    outcomeNumberLabel: "Intervention Number",
    outcomeTitleLabel: "Intervention Title",
    outcomeCategoryLabel: "Intervention Objective",
    supportActivityLabel: "Intervention Activity",
    supportInstructionsLabel: "Intervention Instruction",
    howOftenLabel: "Intervention Frequency",
    noLongerNeedLabel: "No longer need this intervention",
    additionalNoteLabel: "Additional Note",
    addNewDetailsLabel: "Add More Details",
    addNewButtonLabel: "Intervention",
    categoryData: [
      "Adaptive",
      "Cognitive",
      "Academic",
      "Daily Living",
      "Transportation",
      "Therapeutic",
      "Socialization",
      "Communication",
      "Behavior Management",
      "Community Engagement",
      "Self-Skills",
      "Community Engagement",
    ],
  },
  // Individual Support Plan (Essential Supports) labels
  3: {
    typeTitle: "Activity",
    outcomeNumberLabel: "Outcome Number",
    outcomeTitleLabel: "Outcome Title",
    outcomeCategoryLabel: "Life Area",
    supportActivityLabel: "Activity Statement",
    supportInstructionsLabel: "How to Support",
    howOftenLabel: "Activity Frequency",
    noLongerNeedLabel: "No longer need this outcome when ..",
    additionalNoteLabel: "Additional Note",
    addNewDetailsLabel: "Add More Details",
    addNewButtonLabel: "Outcome",
    categoryData: [
      "Employment",
      "Integrated Community Involvement",
      "Community Living",
      "Safety & Security",
      "Daily Life & Employment",
      "Healthy Living",
      "Social & Spirituality",
      "Citizenship & Advocacy",
      "Community Engagement",
    ],
  },
  4: {
    typeTitle: "Measurable Objectives",
    outcomeTitleLabel: "Identified Relevant Attainable Goals",
    supportActivityLabel: "Objectives",
    supportInstructionsLabel: "Intervention Instruction",
    addNewDetailsLabel: "Add More Objectives",
    addNewButtonLabel: "Goal",
  },
};
const ClientSupportPlan = ({ client, clientDetails, planData }) => {
  const [opened, { open, close }] = useDisclosure(false);
  const [opened2, { open: open2, close: close2 }] = useDisclosure(false);
  const [carePlanType, setCarePlanType] = useState("");
  const [selectedTab, setSelectedTab] = useState("active");
  const { state } = useLocation();

  const [row, setRow] = useState(null);
  const [view, setView] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const { count } = useSelector((state) => state.supportPlan);
  const [showCarePlanDetails, setShowCarePlanDetails] = useState(false);
  const [careplanSearch, setCareplanSearch] = useState("");
  const [rowData, setRowData] = useState(null);
  // const carePlanDoc = state?.planDoc;
  const { profile } = useSelector((state) => state?.profile);

  const { plans, addPlanLoading, loading } = useSelector(
    (state) => state?.supportPlan
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const carePlanSelected = (type) => {
    setCarePlanType(type);
    setShowCarePlanDetails(true);
    close2();
    open();
  };

  const { classes } = useStyles();

  const handleAddCarePlanClick = () => {
    setShowCarePlanDetails(true);
    // open2();
  };

  const handleTableBoxClick = () => {
    setShowCarePlanDetails(false);
    setCarePlanType(null);
    setRowData(null);
    setView(false);
  };

  const tabMap = {
    active: "active",
    draft: "draft",
    discontinued: "discontinued",
  };

  useEffect(() => {
    const segment = tabMap[selectedTab];
    if (state?.notificationDoc) {
      getPlans(currentPage, state?.notificationDoc?.client?.id, segment);
    } else if (state?.planDoc) {
      getPlans(currentPage, state?.planDoc?.client?.id, segment);
    } else {
      getPlans(
        currentPage,
        typeof client === "string" ? client : client?.client?.id,
        segment
      );
    }
  }, [currentPage, selectedTab]);

    // Fetch the specific care plan when carePlanDoc exists
  useEffect(() => {
    const fetchCarePlan = async () => {
      if (planData) {
        try {
        const plan = planData?.data?.plan;
        const decryptedName = plan?.client?.name
          ? decrypt(plan.client.name)
          : "";
        const updatedPlan = {
          ...plan,
          client: {
            ...plan.client,
            name: decryptedName,
          },
        };
          setRowData(updatedPlan);
          setShowCarePlanDetails(true);
          setView(true);
        } catch (error) {
        }
      }
    };

    fetchCarePlan();
  }, [planData]);

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <Container fluid className={classes.content} px={0}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div className={classes.btn} style={{ marginTop: "20px" }}>
          <Box className={classes.segmentBTN}>
            <Box style={{ flex: 1 }}>
              <Input
                className={classes.searchInput}
                variant="filled"
                size="sm"
                placeholder="Search"
                icon={<IconSearch />}
                onChange={(e) => {
                  setCareplanSearch(e?.target?.value);
                }}
              />
            </Box>
            <Box className={classes.tabContainer}>
              <Box
                className={`${classes.tab} ${
                  loading
                    ? `${classes.disableTab}`
                    : `${selectedTab === "active" ? classes.activeTab : ""}`
                }`}
                onClick={() => handleTabChange("active")}
              >
                <Text fw={500}>Active</Text>
              </Box>
              <Box
                id="medication-week"
                className={`${classes.tab} ${
                  loading
                    ? `${classes.disableTab}`
                    : `${selectedTab === "draft" ? classes.activeTab : ""}`
                }`}
                onClick={() => handleTabChange("draft")}
              >
                <Text fw={500}>Draft</Text>
              </Box>
              <Box
                id="medication-today"
                className={`${classes.tab} ${
                  loading
                    ? `${classes.disableTab}`
                    : `${
                        selectedTab === "discontinued" ? classes.activeTab : ""
                      }`
                }`}
                onClick={() => handleTabChange("discontinued")}
              >
                <Text fw={500}>Discontinued</Text>
              </Box>
            </Box>
              {!isStaff(profile?.user?.role) ? (
            <AddButton
              title={"Add Plan"}
              BtnIcon={<FaPlus size={15} />}
              onClick={handleAddCarePlanClick}
            />
            ) : null}
          </Box>
        </div>
        {plans?.length > 0 ? (
          <>
            <Text color="#262626" fs={18} fw={600} ff={"Inter"} mt={14}>
              Care Plan List
            </Text>
            <PlanTable
              setRowData={setRowData}
              setShowCarePlanDetails={setShowCarePlanDetails}
              segment={selectedTab}
              currentPage={currentPage}
              client={client}
              setIsView={setView}
              search={careplanSearch}
              rowData={rowData}
            />
            <CustomPagination
              data={count}
              itemsPerPage={10}
              currentPage={currentPage}
              handlePageChange={handlePageChange}
            />
          </>
        ) : (
          !loading && (
            <NoData
              icon={
                selectedTab === "discontinued" ? (
                  <NoDiscontinuedPlansSvg />
                ) : (
                  <NoCarePlanDataSvg />
                )
              }
              title={
                selectedTab === "discontinued"
                  ? "No Archived Care Plans"
                  : selectedTab === "active"
                  ? "No Active Care Plans"
                  : "No Draft Plan Data"
              }
              discription={
                selectedTab === "discontinued"
                  ? "Find all your discontinued care plans here!"
                  : selectedTab === "active"
                  ? "Find all your active care plans here!"
                  : "Find all your draft care plans here!"
              }
            />
          )
        )}
      </div>
      <SelectCarePlanTypeModal
        open={opened2}
        close={close2}
        onSelect={carePlanSelected}
        carePlanType={carePlanType}
      />
      <CarePlanDetailsDrawer
        isOpen={showCarePlanDetails}
        rowData={rowData}
        // onSelect={carePlanSelected}
        segment={selectedTab}
        client={client}
        carePlanType={carePlanType}
        setRowData={setRowData}
        addPlanLoading={addPlanLoading}
        setShowCarePlanDetails={setShowCarePlanDetails}
        handleTableBoxClick={handleTableBoxClick}
        edit={showCarePlanDetails && rowData ? true : undefined}
        view={showCarePlanDetails && rowData && view ? true : undefined}
        clientDetails={clientDetails}
      />
    </Container>
  );
};

const NoData = ({ icon, title, discription, children }) => {
  const { classes } = useStyles();
  return (
    <Box display="flex" w="100%" my={40}>
      <Flex
        mx="auto"
        direction="column"
        justify="center"
        align="center"
        className={classes.noDataContainer}
      >
        <Box className="iconParent">{icon}</Box>
        <Text color="#171717" fs={20} fw={600} ff="Inter" mt={12}>
          {title}
        </Text>
        <Text color="#737373" fs={16} fw={400} ta="center" ff="Inter" mt={4}>
          {discription}
        </Text>
        {children}
      </Flex>
    </Box>
  );
};

export default ClientSupportPlan;
